import styles from './Warning.module.css';

const Warning = ({ scale = 0.5 }) => {
    return (
        <div className={styles["sa"]} style={{transform: `scale(${scale})`}}>
            <div class={styles["sa-warning"]}>
                <div class={styles["sa-warning-body"]}></div>
                <div class={styles["sa-warning-dot"]}></div>
            </div>
        </div>
    );
};

export default Warning;
